export enum CarouselContentType {
    STANDARD = "STANDARD",
    EXPANDED = "EXPANDED"
}
